import { createContext, ReactNode, useCallback, useContext, useState } from "react";

type OpenOpts = { restaurantId?: string };

type Ctx = {
  open: boolean;
  prefillRestaurantId: string | null;
  openSheet: (opts?: OpenOpts) => void;
  closeSheet: () => void;
};

const LogSheetContext = createContext<Ctx | null>(null);

export function LogSheetProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [prefillRestaurantId, setPrefill] = useState<string | null>(null);

  const openSheet = useCallback((opts?: OpenOpts) => {
    setPrefill(opts?.restaurantId ?? null);
    setOpen(true);
  }, []);
  const closeSheet = useCallback(() => {
    setOpen(false);
    // Clear prefill after close animation
    setTimeout(() => setPrefill(null), 300);
  }, []);

  return (
    <LogSheetContext.Provider value={{ open, prefillRestaurantId, openSheet, closeSheet }}>
      {children}
    </LogSheetContext.Provider>
  );
}

export function useLogSheet() {
  const ctx = useContext(LogSheetContext);
  if (!ctx) throw new Error("useLogSheet must be used inside LogSheetProvider");
  return ctx;
}
